import "./ProductSelector.scss"
import React from "react"
import { observer } from "mobx-react"
import { AppHeader, AppPanel } from "../../lib"
import { productStore, addProductStore } from "../../stores"

import caseImg from "../../assets/products/case.png"
import hatImg from "../../assets/products/hat.png"
import hoodieImg from "../../assets/products/hoodie.png"
import leggingsImg from "../../assets/products/leggings.png"
import mugImg from "../../assets/products/mug.png"
import posterImg from "../../assets/products/poster.png"
import teeImg from "../../assets/products/tee-subli.png"

// TODO: just pull these from baseProducts
const products = [
  {
    id: 71,
    img: teeImg,
    label: "t-shirt",
  },
  {
    id: null,
    img: hoodieImg,
    label: "hoodie",
  },
  {
    id: null,
    img: hatImg,
    label: "hat",
  },
  {
    id: null,
    img: leggingsImg,
    label: "leggings",
  },
  {
    id: null,
    img: caseImg,
    label: "phone case",
  },
  {
    id: null,
    img: mugImg,
    label: "mug",
  },
  {
    id: null,
    img: posterImg,
    label: "poster",
  },
]

const ProductSelectorOption = observer(props => {
  const exists = productStore.baseProducts.has(props.id)
  return (
    <div
      className="ProductSelectorOption"
      disabled={!exists}
      onClick={() => exists && addProductStore.selectProduct(props.id)}>
      <img src={props.img} alt="" />
      <label>{props.label}</label>
    </div>
  )
})

const ProductSelector = () => {
  return (
    <div className="ProductSelector">
      <ul className="ProductSelector_list">
        {products.map((product, index) => (
          <li key={index}>
            <ProductSelectorOption {...product} />
          </li>
        ))}
      </ul>
    </div>
  )
}

ProductSelector.displayName = "ProductSelector"

export default observer(ProductSelector)



// WEBPACK FOOTER //
// ./src/products/add/ProductSelector.js